import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, Params, NavigationExtras } from '@angular/router';
import { PopupService } from 'src/app/services/general/popup.service';
import { LinkService } from 'src/app/services/general/link.service';
import { Item } from 'src/app/interfaces/transaction';
import { Voucher } from 'src/app/interfaces/voucher';

@Component({
  selector: 'app-product-account-comparison',
  templateUrl: './product-account-comparison.page.html',
  styleUrls: ['./product-account-comparison.page.scss'],
})
export class ProductAccountComparisonPage implements OnInit, OnDestroy {

  iapMode: boolean;
  /**
   * Currency
   */
  currency: string;
  /**
   * Item list
   */
  itemList: Item[];
  /**
   * Voucher ID
   */
  voucherId: string;
  private referralRate: number;
  /**
   * Referral ID
   */
  private referralCode: string;
  /**
   * Voucher
   */
  voucher: Voucher;
  /**
   * Bulk Mode
   */
  bulkMode: boolean;
  /**
   * Gift Mode
   */
  giftMode: boolean;
  /**
   * Upgrade trial to premium flag
   */
  upgradeTrial: boolean;
  /**
   * Upgrade mode for upgrading to full premium package
   */
  upgradeMode: boolean;
  accountId: string;
  /**
   * Disable upgrade
   */
  disableUpgrade: boolean;
  /**
   * Disable bulk mode
   */
  disableBulkMode: boolean;

  backPremiumPage: boolean;

  private backAddPage: boolean;

  private disableCreditPrompt: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private linkService: LinkService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
  }

  /**
   * Watch route
   */
   watchRoute() {
    this.route.params.subscribe(async (param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;
      await this.popupService.presentLoading();

      if (state?.accountId) {
        this.accountId = state?.accountId;
      } else if (param?.accountId) {
        this.accountId = param?.accountId;
      }

      if (state?.currency) {
        this.currency = state?.currency;
      } else if (param?.currency) {
        this.currency = param?.currency;
      }

      if (state?.itemList) {
        this.itemList = state?.itemList;
      } else {
        this.itemList = [];
      }

      if (state?.referralRate) {
        this.referralRate = state.referralRate;
      } else if (param?.referralRate) {
        this.referralRate = param.referralRate;
      }

      if (state?.referralCode && state?.referralCode !== 'null') {
        this.referralCode = state?.referralCode;
      } else if (param?.referralCode && param?.referralCode !== 'null') {
        this.referralCode = param.referralCode;
      } else {
        this.referralCode = '';
      }

      if (state?.voucher) {
        this.voucher = state?.voucher;
      } else {
        this.voucher = null;
      }

      if (state?.voucherId && state?.voucherId !== 'null') {
        this.voucherId = state.voucherId;
      } else if (param?.voucherId && param.voucherId !== 'null') {
        this.voucherId = param.voucherId;
      } else if (this.voucher?.voucherId) {
        this.voucherId = this.voucher.voucherId;
      } else {
        this.voucherId = '';
      }

      if (state?.giftMode) {
        this.giftMode = state.giftMode;
      } else if (param?.giftMode) {
        this.giftMode = param.giftMode;
      } else {
        this.giftMode = false;
      }

      if (state?.bulkMode) {
        this.bulkMode = state?.bulkMode;
      } else if (param?.bulkMode) {
        this.bulkMode = param.bulkMode;
      } else {
        this.bulkMode = false;
      }

      if (state?.upgradeMode) {
        this.upgradeMode = true;
      } else if (param?.upgradeMode) {
        this.upgradeMode = true;
      } else {
        this.upgradeMode = false;
      }

      if (state?.iapMode) {
        this.iapMode = true;
      } else if (param?.iapMode) {
        this.iapMode = true;
      } else {
        this.iapMode = false;
      }

      if (state?.upgradeTrial) {
        this.upgradeTrial = true;
      } else if (param?.upgradeTrial) {
        this.upgradeTrial = true;
      } else {
        this.upgradeTrial = false;
      }

      if (state?.disableUpgrade) {
        this.disableUpgrade = true;
      } else if (param?.disableUpgrade) {
        this.disableUpgrade = true;
      } else {
        this.disableUpgrade = false;
      }

      if (state?.disableCreditPrompt) {
        this.disableCreditPrompt = true;
      } else if (param?.disableCreditPrompt) {
        this.disableCreditPrompt = true;
      } else {
        this.disableCreditPrompt = false;
      }

      if (state?.backPremiumPage) {
        this.backPremiumPage = true;
      } else if (param?.backPremiumPage) {
        this.backPremiumPage = true;
      } else {
        this.backPremiumPage = false;
      }

      if (state?.backAddPage) {
        this.backAddPage = true;
      } else if (param?.backAddPage) {
        this.backAddPage = true;
      } else {
        this.backAddPage = false;
      }

      this.popupService.dismissLoading();
    });
  }

  ionViewWillEnter() {
  }

  ionViewWillLeave() {
  }

  goBack() {
    this.linkService.goMainPage();
  }

  goProductAccountPage() {
    this.router.navigate(['/subscription/account'], this.generateParam());
  }

  generateParam(): NavigationExtras {
    const navigationExtras: NavigationExtras = {
      state: {
        accountId: this.accountId,
        currency: this.currency,
        itemList: this.itemList,
        referralCode: this.referralCode,
        referralRate: this.referralRate,
        voucher: this.voucher,
        voucherId: this.voucherId,
        giftMode: this.giftMode,
        bulkMode: this.bulkMode,
        iapMode: this.iapMode,
        upgradeTrial: this.upgradeTrial,
        upgradeMode: this.upgradeMode,
        disableUpgrade: this.disableUpgrade,
        disableCreditPrompt: this.disableCreditPrompt,
        backPremiumPage: this.backPremiumPage,
        backAddPage: this.backAddPage,
      }
    };
    return navigationExtras;
  }

  goPremiumPage() {
    this.router.navigate(['/subscription/premium'], this.generateParam());
  }

}
